import { IoMdSend } from "react-icons/io";
import { IoArrowBack, IoCheckmarkDone, IoChatbubbleEllipsesOutline } from "react-icons/io5";
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { url } from "../url";
import Loading from "./allcomponent/Loading";
import { getSocket, joinTravelRoom, leaveTravelRoom, SOCKET_EVENTS } from "../socket";

// ===== Helper برای نمایش ساعت =====
const formatTime = (dateStr) => {
    if (!dateStr) return '';
    try {
        const d = new Date(dateStr);
        return d.toLocaleTimeString('fa-IR', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    } catch {
        return '';
    }
};

// ===== کامپوننت کمکی: حباب پیام =====
const MessageBubble = ({ item, isLast }) => {
    const isDriver = item?.sender?.driver;
    const isPassenger = item?.sender?.passenger;

    return (
        <div
            className={`flex ${isPassenger ? 'justify-start' : 'justify-end'} chat-msg-enter`}
        >
            <div
                className={`
                    max-w-[78%] px-4 py-2.5 shadow-sm
                    transition-all duration-300
                    ${isDriver
                        ? 'bg-gradient-to-br from-[#4F48EC] to-[#6366f1] text-white rounded-2xl rounded-br-sm shadow-indigo-200'
                        : 'bg-white border border-slate-200 text-slate-800 rounded-2xl rounded-bl-sm shadow-slate-200'
                    }
                `}
            >
                <p className="text-[15px] leading-7 whitespace-pre-wrap break-words">
                    {item.message}
                </p>
                <div className={`flex items-center justify-end gap-1 mt-1 ${
                    isDriver ? 'text-white/80' : 'text-slate-400'
                }`}>
                    <span className="text-[11px] tabular-nums" style={{ fontFamily: 'IRANSansFaNum' }}>
                        {formatTime(item.createdAt)}
                    </span>
                    {isDriver && (
                        <IoCheckmarkDone className="text-xs" />
                    )}
                </div>
            </div>
        </div>
    );
};

// ===== کامپوننت کمکی: حالت خالی =====
const EmptyState = () => (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center chat-msg-enter">
        <div className="w-24 h-24 rounded-full bg-gradient-to-br from-indigo-50 to-blue-100 flex items-center justify-center mb-5 shadow-inner">
            <IoChatbubbleEllipsesOutline className="w-12 h-12 text-[#4F48EC]" />
        </div>
        <h3 className="text-lg font-bold text-slate-700 mb-2">هنوز پیامی رد و بدل نشده</h3>
        <p className="text-sm text-slate-500 max-w-xs leading-6">
            اولین پیام را برای مسافر ارسال کنید تا گفتگو آغاز شود
        </p>
    </div>
);

const DriverMessage = () => {

    const refMessageScroller = useRef(null);
    const navigate = useNavigate();
    const [noMessages, setNoMessages] = useState(false);
    const [specificMessagePage, setSpecificMessagePage] = useState([]);
    const [driverMessage, setDriverMessage] = useState("")
    const [refreshData, setRefreshData] = useState(false)

    const [loadingSendMessage, setLoadingSendMessage] = useState(false)

    const id = useParams();
    console.log('id bemola : ', id);

    const finalSendMessage = () => {
        setLoadingSendMessage(true)
        axios.post(`${url}/travel-message/v1/driver-send-message`,
            {
                message: driverMessage,
                travel_id: id.id
            },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            }).then(res => {
            setLoadingSendMessage(false)
            setRefreshData(!refreshData);
            setDriverMessage("")
        }).catch(err => {
            setLoadingSendMessage(false)
        })
    }

    useEffect(() => {
        axios.get(`${url}/travel-message/v1/get-driver-single-travel-messages/${id.id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }
        })
            .then(res => {
                setSpecificMessagePage(res.data.data)
                setNoMessages(false)
            }).catch(err => {
            // error handling
            setNoMessages(true)
        })
    }, [noMessages, refreshData, id.id])

    // --- WebSocket: دریافت لحظه‌ای پیام جدید مسافر بدون رفرش ---
    useEffect(() => {
        const socket = getSocket();
        if (!socket || !id.id) return;

        joinTravelRoom(id.id);

        const onNewMessage = (payload) => {
            // فقط پیام‌های همین سفر
            if (payload?.travel_id && String(payload.travel_id) !== String(id.id)) return;
            if (payload?.message) {
                setSpecificMessagePage(prev => {
                    // جلوگیری از پیام تکراری (وقتی خودمان فرستنده هستیم)
                    const exists = prev.some(m => m._id && m._id === payload.message._id);
                    return exists ? prev : [...prev, payload.message];
                });
                setNoMessages(false);
            }
        };

        socket.on(SOCKET_EVENTS.TRAVEL_MESSAGE_CREATED, onNewMessage);

        return () => {
            socket.off(SOCKET_EVENTS.TRAVEL_MESSAGE_CREATED, onNewMessage);
            leaveTravelRoom(id.id);
        };
    }, [id.id])


    useEffect(() => {
        if (specificMessagePage?.length > 4) {
            const scroller = refMessageScroller.current?.closest("#activescrollbar");
            scroller?.scrollTo({ top: scroller.scrollHeight, behavior: 'smooth' });
        }
    }, [specificMessagePage]);

    return (
        <>
            {localStorage.getItem("token") !== null ? (
                <div className="min-h-screen bg-gradient-to-b w-full from-slate-50 via-slate-50 to-indigo-50/30 flex flex-col">

                    {/* ===== Header ===== */}
                    <div className="sticky top-0 z-20 bg-white/80 backdrop-blur-xl border-b border-slate-200/70 shadow-sm">
                        <div className="max-w-4xl mx-auto flex items-center gap-3 px-4 py-3">
                            <button
                                onClick={() => navigate(-1)}
                                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-slate-100 active:scale-95 transition-all"
                                aria-label="بازگشت"
                            >
                                <IoArrowBack className="text-xl text-slate-700" />
                            </button>
                            <div className="flex-1 min-w-0">
                                <h1 className="font-bold text-slate-800 text-base">گفتگو با مسافر</h1>
                                <p className="text-[11px] text-slate-500 truncate">پیام‌ها به‌صورت لحظه‌ای ارسال می‌شوند</p>
                            </div>
                            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#4F48EC] to-[#6366f1] flex items-center justify-center text-white font-bold shadow-md shadow-indigo-200">
                                م
                            </div>
                        </div>
                    </div>

                    {/* ===== Message List ===== */}
                    <div
                        className="flex-1 min-h-0 overflow-y-auto custom-chat-scroll"
                        id="activescrollbar"
                        style={{
                            backgroundImage: `radial-gradient(circle at 20% 10%, rgba(79,72,236,0.04) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(99,102,241,0.04) 0%, transparent 50%)`
                        }}
                    >
                        <div className="max-w-3xl mx-auto px-4 py-6 flex flex-col gap-2.5">
                            {noMessages ? (
                                <EmptyState />
                            ) : (
                                specificMessagePage.map((item, index) => (
                                    <MessageBubble
                                        key={index}
                                        item={item}
                                        isLast={index === specificMessagePage.length - 1}
                                    />
                                ))
                            )}
                            <div ref={refMessageScroller}></div>
                        </div>
                    </div>

                    {/* ===== Input Bar ===== */}
                    <div className="sticky bottom-0 bg-white/90 backdrop-blur-xl border-t border-slate-200/70 shadow-[0_-4px_20px_rgba(0,0,0,0.04)]">
                        <div className="max-w-3xl mx-auto p-3">
                            <div className="flex items-end gap-2 bg-slate-100/80 rounded-2xl p-1.5 focus-within:bg-white focus-within:ring-2 focus-within:ring-[#4F48EC]/30 focus-within:border-[#4F48EC]/20 border border-transparent transition-all">
                                <input
                                    value={driverMessage}
                                    onChange={(e) => setDriverMessage(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && !e.shiftKey && driverMessage.trim()) {
                                            e.preventDefault();
                                            finalSendMessage();
                                        }
                                    }}
                                    className="flex-1 bg-transparent outline-none px-4 py-3 text-slate-800 placeholder-slate-400 text-[15px]"
                                    placeholder="پیام خود را بنویسید..."
                                />
                                <button
                                    disabled={loadingSendMessage || !driverMessage.trim()}
                                    onClick={finalSendMessage}
                                    className="w-11 h-11 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#4F48EC] to-[#6366f1] text-white hover:shadow-lg hover:shadow-indigo-300 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed disabled:shadow-none transition-all flex-shrink-0"
                                    aria-label="ارسال پیام"
                                >
                                    {loadingSendMessage ? (
                                        <Loading />
                                    ) : (
                                        <IoMdSend className="text-lg" />
                                    )}
                                </button>
                            </div>
                            <p className="text-center text-[10px] text-slate-400 mt-2">
                                برای ارسال Enter را بزنید
                            </p>
                        </div>
                    </div>

                    {/* ===== CSS داخلی برای انیمیشن و اسکرول‌بار ===== */}
                    <style>{`
                        @keyframes chatMsgEnter {
                            from {
                                opacity: 0;
                                transform: translateY(8px);
                            }
                            to {
                                opacity: 1;
                                transform: translateY(0);
                            }
                        }
                        .chat-msg-enter {
                            animation: chatMsgEnter 0.25s ease-out both;
                        }
                        .custom-chat-scroll::-webkit-scrollbar {
                            width: 6px;
                        }
                        .custom-chat-scroll::-webkit-scrollbar-track {
                            background: transparent;
                        }
                        .custom-chat-scroll::-webkit-scrollbar-thumb {
                            background: #cbd5e1;
                            border-radius: 8px;
                        }
                        .custom-chat-scroll::-webkit-scrollbar-thumb:hover {
                            background: #94a3b8;
                        }
                    `}</style>
                </div>
            ) : (
                <></>
            )}
        </>
    )
}

export default DriverMessage